import { Quote, QuoteProps } from '@cinch-labs/design-system'
import {
  VapsTrustPilotQuote as TrustPilotQuoteProps,
  storyblokEditable,
} from '@cinch-nx/data-storyblok'
import cx from 'classnames'

import styles from './trustpilot-quote.module.css'

export const TrustPilotQuote: React.FC<TrustPilotQuoteProps> = (blok) => {
  const {
    quote,
    author,
    rating,
    hideOnSmallScreen = false,
    hideOnLargeScreen = false,
  } = blok

  return (
    <div
      data-testid="trustpilot-quote"
      {...storyblokEditable(blok)}
      className={cx(styles.wrapper, {
        [styles.hideOnSmallScreen]: hideOnSmallScreen,
        [styles.hideOnLargeScreen]: hideOnLargeScreen,
      })}
    >
      <Quote
        text={quote}
        author={author}
        rating={Number.parseInt(rating, 10) as QuoteProps['rating']}
      />
    </div>
  )
}

export default TrustPilotQuote
